module.exports = __webpack_public_path__ + "img/AI识别软件问题.d3d8f120.jpg";